import { atom } from "recoil";

export const notesListState = atom({
  key: "notesListState",
  default: [],
});
